import React, { useState, useEffect } from 'react';
import HeroImage1 from '../images/hero-images/pragicts-partnerships-banner-global-partnerships.jpg'; 
import HeroImage2 from '../images/hero-images/pragicts-partnerships-banner-force-to-reckon-with.jpg'; 
import HeroImage3 from '../images/hero-images/pragicts-partnerships-banner-cyber-security.jpg'; 
import HeroImage4 from '../images/hero-images/pragicts-partnerships-banner-ai-robotics.jpg'; 
import HeroImage5 from '../images/hero-images/pragicts-partnerships-banner-ditgital-outreach.jpg'; 
import HeroImage6 from '../images/hero-images/pragicts-partnerships-banner-itops.jpg'; 

const slides = [
    {
        id: 1,
        image: HeroImage1,
        mainText: '<span>40+ Strategic</span> Global Partnerships ',
        subText:'Forefront in Engineering & Technologies',
    },
    {
        id: 2,
        image: HeroImage2,
        mainText: '<span>Global Strategic</span> Partnerships',
        subText:'Force To Reckon With',
    },
    {
        id: 3,
        image: HeroImage3,
        mainText: '<span>Global Strategic</span> Partnerships',
        subText:'Cyber Security',
    },
    {
        id: 4,
        image: HeroImage4,
        mainText: '<span>Global Strategic</span> Partnerships',
        subText:'Automation, AI, Robotics',
    },
    {
        id: 5,
        image: HeroImage5,
        mainText: '<span>Global Strategic</span> Partnerships',
        subText:'Digital Outreach',
    },
    {
        id: 6,
        image: HeroImage6,
        mainText: '<span>Global Strategic</span> Partnerships',
        subText:'ITOps, CloudOps',
    },
];

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                            <h4>{slide.subText}</h4>
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides;
